module.exports = __webpack_public_path__ + "img/arrow-right.2047db47.svg";